import { Link } from "react-router-dom";
import { loadRun, TOTAL_STEPS } from "../lib/runState";

const comingSoon = [
  { name: "Disease Monitoring", icon: "🧪", desc: "Weekly pool testing review and dashboard publication." },
  { name: "Larval / Source Reduction", icon: "💧", desc: "Site inspections, dip counts, and treatment tracking." },
  { name: "Service Requests", icon: "📞", desc: "Resident request intake, dispatch, and resolution." },
];

export default function WorkflowsPage() {
  const run = loadRun();
  const complete = run.step > TOTAL_STEPS;

  return (
    <div>
      <h2 className="font-extrabold text-[26px] tracking-tight mb-6">Workflows</h2>
      <div className="grid grid-cols-1 min-[640px]:grid-cols-2 gap-4">
        <Link to="/workflows/adult-control" className="ui-card p-5 hover:shadow-lg2 transition border-l-4 !border-l-wnv">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-sm2 bg-wnv-tint flex items-center justify-center text-lg">🚨</span>
            <div>
              <div className="font-extrabold text-[15.5px]">Adult Control Run</div>
              <span className="pill bg-wnv-tint text-wnv mt-1">
                {complete ? "Run complete" : `Step ${run.step} of ${TOTAL_STEPS}`}
              </span>
            </div>
          </div>
          <p className="text-ink-soft text-[13px] mt-3">
            VectorSurv data → positives → treatment areas → publish → notify → field prep → reconcile.
          </p>
          <span className="btn-primary inline-block mt-3 !py-1.5 text-sm">{complete ? "Review run" : "Resume run"}</span>
        </Link>

        {comingSoon.map((wf) => (
          <div key={wf.name} className="ui-card p-5 opacity-55">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-sm2 bg-paper-2 flex items-center justify-center text-lg">{wf.icon}</span>
              <div>
                <div className="font-extrabold text-[15.5px]">{wf.name}</div>
                <span className="pill bg-paper-2 text-ink-faint mt-1">Work in progress</span>
              </div>
            </div>
            <p className="text-ink-soft text-[13px] mt-3">{wf.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
